import React, { useEffect, useState } from 'react'
import { Steps } from 'primereact/steps'
import './steps.scss'

interface LuxStepsProps {
    steps: [
        {
            label: string
            number: number
            className: any
            content: any
        }
    ]
    activeStep: number
    onStepChange?: (val: number) => void
    nonLinearSteps?: boolean
}

const LuxSteps = (props: LuxStepsProps) => {
    const { steps, activeStep, onStepChange, nonLinearSteps }: LuxStepsProps =
        props

    const [activeIndex, setActiveIndex] = useState(0)
    const [maxIndex, setMaxIndex] = useState(activeStep)
    const [stepsObj, setStepsObj] = useState([])

    useEffect(() => {
        if (activeStep > maxIndex && !nonLinearSteps) {
            setMaxIndex(activeStep)
        }
        setActiveIndex(activeStep)
    }, [activeStep])

    useEffect(() => {
        let _steps = steps.map((item) => ({
            ...item,
            label: item.label,
            disabled:
                item.number - 1 > maxIndex && !nonLinearSteps ? true : false,
        }))
        setStepsObj(_steps)
    }, [steps])

    return (
        <div className="wardrobe-steps">
            <div className="card" data-length={steps.length}>
                <Steps
                    model={stepsObj}
                    readOnly={false}
                    className={'tabview'}
                    activeIndex={activeIndex}
                    onSelect={(e) => {
                        setActiveIndex(e.index)
                        onStepChange && onStepChange(e.index)
                    }}
                />
                {steps.map((step, index) => {
                    return (
                        <div key={index} hidden={activeIndex !== index}>
                            {step.content}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default LuxSteps
